import type { FunctionComponent } from "react";
import { Fragment } from "react";

import ImageActivities from "./img-activities.png";
import ImageInvolved from "./img-involved.png";
import ImageLearning from "./img-learning.png";
import {
  BackgroundImageLine,
  Container,
  ContentWrapper,
  Description,
  Header,
  ImageWrapper,
  LineWrapper,
  MobileContentHeadline,
  StyledImg,
  SubContentDescription,
  SubContentHeadline,
  SubContentWrapper,
  TabletContentHeadline,
  TextWrapper,
  Wrapper,
} from "./styles";

export const PostiesOurFeatures: FunctionComponent = () => {
  const texts = {
    contents: [
      {
        headline: "Interactive reading",
        image: ImageLearning.src,
        subContents: [
          {
            description:
              "Our articles come with key phrases and words to learn, as well as games and exercises to improve vocabulary.",
            headline: "Stories to explore",
          },
          {
            description:
              "Stay informed with the latest happenings around the world. Our news summaries for kids help them understand why global events matter, and encourage further exploration.",
            headline: "News",
          },
          {
            description:
              "Improve listening and pronunciation skills with our audio feature that reads stories out loud.",
            headline: "Read it out",
          },
        ],
      },
      {
        headline: "Get children involved",
        image: ImageInvolved.src,
        subContents: [
          {
            description:
              "A corner for students to write letters expressing their thoughts on a variety of topics. Student recommendations provide suggestions on what to read and watch next.",
            headline: "Have your say",
          },
          {
            description:
              "Our fun photo caption contest gives learners the chance to showcase their creativity and get published.",
            headline: "Ha-ha-happenings",
          },
        ],
      },
      {
        headline: "Engaging activities",
        image: ImageActivities.src,
        subContents: [
          {
            description:
              "Our exciting activities bring students, teachers, and parents together through creativity. Create toys, make art, and cook simple dishes.",
            headline: "Hands-on projects",
          },
          {
            description:
              "Explore science and technology topics in an engaging and relevant way with our visual content.",
            headline: "STEAM page",
          },
          {
            description:
              "Our psychologists are ready to answer all your questions about growing up. From health to happiness, and everything in between, discover our words of wisdom.",
            headline: "Life lessons",
          },
        ],
      },
    ],
    description: "Explore, learn and be engaged",
    headline: "Our content",
  };

  const contents = texts.contents.map((content, contentKey) => (
    <Fragment key={contentKey}>
      <ContentWrapper $isEven={contentKey % 2 === 0}>
        <ImageWrapper>
          <MobileContentHeadline>{content.headline}</MobileContentHeadline>
          <StyledImg src={content.image} />
        </ImageWrapper>
        <TextWrapper $isEven={contentKey % 2 === 0}>
          <TabletContentHeadline>{content.headline}</TabletContentHeadline>
          {content.subContents.map((subContent, subContentKey) => (
            <SubContentWrapper key={subContentKey}>
              <SubContentHeadline>{subContent.headline}</SubContentHeadline>
              <SubContentDescription>{subContent.description}</SubContentDescription>
            </SubContentWrapper>
          ))}
        </TextWrapper>
      </ContentWrapper>
      {contentKey !== texts.contents.length - 1 && (
        <LineWrapper>
          <BackgroundImageLine />
        </LineWrapper>
      )}
    </Fragment>
  ));

  return (
    <Container>
      <Wrapper>
        <Header>{texts.headline}</Header>
        <Description>{texts.description}</Description>
        {contents}
      </Wrapper>
    </Container>
  );
};

PostiesOurFeatures.displayName = "PostiesOurFeatures";
